<div class="main-container">
  <div class="success-container" [@slideInOut]="notificationState">
    <div class="flex">
      <img src="assets/icons/notification-v.svg" />
    </div>
    <div class="success-container__text">
      {{ notificationText }}
    </div>
    <div class="flex img-space" (click)="close()">
      <img src="assets/icons/notification-x.svg" />
    </div>
  </div>
</div>
